import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '../assets/page-image/wyrz/banner.png';
const _hoisted_1 = {
  class: "rz-apply-wrapper"
};
const _hoisted_2 = {
  class: "rz-apply-page"
};
const _hoisted_3 = {
  class: "form-container"
};
const _hoisted_4 = {
  class: "form-item full-width"
};
const _hoisted_5 = {
  for: "companyName",
  class: "form-label required"
};
const _hoisted_6 = {
  class: "form-row"
};
const _hoisted_7 = {
  class: "form-item"
};
const _hoisted_8 = {
  for: "contactPerson",
  class: "form-label required"
};
const _hoisted_9 = {
  class: "form-item"
};
const _hoisted_10 = {
  for: "phone",
  class: "form-label required"
};
const _hoisted_11 = {
  class: "form-item full-width"
};
const _hoisted_12 = {
  for: "projectType",
  class: "form-label required"
};
const _hoisted_13 = {
  class: "form-item full-width"
};
const _hoisted_14 = {
  for: "other",
  class: "form-label"
};
const _hoisted_15 = {
  class: "form-row"
};
const _hoisted_16 = {
  class: "form-item"
};
const _hoisted_17 = {
  for: "area",
  class: "form-label"
};
const _hoisted_18 = {
  class: "form-item"
};
const _hoisted_19 = {
  for: "siteRequirement",
  class: "form-label"
};
const _hoisted_20 = {
  class: "form-item full-width"
};
const _hoisted_21 = {
  for: "fileUpload",
  class: "form-label"
};
const _hoisted_22 = {
  class: "upload-area"
};
const _hoisted_23 = {
  key: 0,
  class: "file-name"
};
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import Footer from '@/components/Footer.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'RzApply',
  setup(__props) {
    const router = useRouter();
    const fileInput = ref(null);
    const fileName = ref('');
    const formData = ref({
      companyName: '',
      contactPerson: '',
      phone: '',
      projectType: '',
      other: '',
      area: '',
      siteRequirement: '',
      file: null
    });
    const triggerFileInput = () => {
      fileInput.value?.click();
    };
    const handleFileChange = event => {
      const target = event.target;
      if (target.files && target.files.length > 0) {
        formData.value.file = target.files[0];
        fileName.value = target.files[0].name;
      }
    };
    const handleSubmit = () => {
      // 验证必填项
      if (!formData.value.companyName) {
        alert('请填写公司名称');
        return;
      }
      if (!formData.value.contactPerson) {
        alert('请填写联系人');
        return;
      }
      if (!formData.value.phone) {
        alert('请填写电话');
        return;
      }
      if (!formData.value.projectType) {
        alert('请选择入驻项目类型');
        return;
      }
      // TODO: 提交表单数据到后端
      // console.log('提交表单数据：', formData.value);
      alert('申请提交成功！');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[19] || (_cache[19] = _createElementVNode("div", {
        class: "banner-wrapper"
      }, [_createElementVNode("div", {
        class: "banner"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "我要入驻"
      })])], -1)), _createElementVNode("div", _hoisted_2, [_cache[18] || (_cache[18] = _createElementVNode("div", {
        class: "page-title"
      }, "入驻申请", -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("form", {
        onSubmit: _withModifiers(handleSubmit, ["prevent"])
      }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("label", _hoisted_5, [_cache[7] || (_cache[7] = _createTextVNode(" 公司名称 ", -1)), _withDirectives(_createElementVNode("input", {
        id: "companyName",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.companyName = $event),
        type: "text",
        class: "form-input",
        placeholder: "请填写公司的全称"
      }, null, 512), [[_vModelText, formData.value.companyName]])])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("label", _hoisted_8, [_cache[8] || (_cache[8] = _createTextVNode(" 联系人 ", -1)), _withDirectives(_createElementVNode("input", {
        id: "contactPerson",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.contactPerson = $event),
        type: "text",
        class: "form-input",
        placeholder: "请填写名"
      }, null, 512), [[_vModelText, formData.value.contactPerson]])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("label", _hoisted_10, [_cache[9] || (_cache[9] = _createTextVNode(" 电话 ", -1)), _withDirectives(_createElementVNode("input", {
        id: "phone",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value.phone = $event),
        type: "text",
        class: "form-input",
        placeholder: "请填写号码"
      }, null, 512), [[_vModelText, formData.value.phone]])])])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("label", _hoisted_12, [_cache[11] || (_cache[11] = _createTextVNode(" 入驻项目类型 ", -1)), _withDirectives(_createElementVNode("select", {
        id: "projectType",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.value.projectType = $event),
        class: "form-select"
      }, [...(_cache[10] || (_cache[10] = [_createStaticVNode("<option value=\"\" data-v-2045bb75>科技类型项目</option><option value=\"生物医药\" data-v-2045bb75>生物医药</option><option value=\"电子信息\" data-v-2045bb75>电子信息</option><option value=\"新材料\" data-v-2045bb75>新材料</option><option value=\"高端装备\" data-v-2045bb75>高端装备</option><option value=\"其他\" data-v-2045bb75>其他</option>", 6)]))], 512), [[_vModelSelect, formData.value.projectType]])])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("label", _hoisted_14, [_cache[12] || (_cache[12] = _createTextVNode(" 其他 ", -1)), _withDirectives(_createElementVNode("textarea", {
        id: "other",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => formData.value.other = $event),
        class: "form-textarea",
        placeholder: "请简述上述需求项目及企业信息"
      }, null, 512), [[_vModelText, formData.value.other]])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("label", _hoisted_17, [_cache[13] || (_cache[13] = _createTextVNode(" 需求面积 ", -1)), _withDirectives(_createElementVNode("input", {
        id: "area",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formData.value.area = $event),
        type: "text",
        class: "form-input",
        placeholder: "所需要的面积"
      }, null, 512), [[_vModelText, formData.value.area]])])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("label", _hoisted_19, [_cache[14] || (_cache[14] = _createTextVNode(" 场地需求 ", -1)), _withDirectives(_createElementVNode("input", {
        id: "siteRequirement",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => formData.value.siteRequirement = $event),
        type: "text",
        class: "form-input",
        placeholder: "所需要的场地"
      }, null, 512), [[_vModelText, formData.value.siteRequirement]])])])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("label", _hoisted_21, [_cache[15] || (_cache[15] = _createTextVNode(" 支持上传公司业务文件 ", -1)), _createElementVNode("input", {
        id: "fileUpload",
        ref_key: "fileInput",
        ref: fileInput,
        type: "file",
        accept: ".zip,.7z,.doc,.docx",
        style: {
          "display": "none"
        },
        onChange: handleFileChange
      }, null, 544)]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", {
        class: "upload-box",
        onClick: triggerFileInput
      }, [...(_cache[16] || (_cache[16] = [_createStaticVNode("<div class=\"upload-icon\" data-v-2045bb75><svg width=\"60\" height=\"60\" viewBox=\"0 0 60 60\" fill=\"#5B7FC7\" data-v-2045bb75><path d=\"M40 20H35V10H25V20H20L30 30L40 20Z\" data-v-2045bb75></path><path d=\"M15 35V45H45V35H50V50H10V35H15Z\" data-v-2045bb75></path></svg></div><div class=\"upload-text\" data-v-2045bb75>格式要求：zip、7z、word</div>", 2)]))]), fileName.value ? (_openBlock(), _createElementBlock("div", _hoisted_23, "已选择：" + _toDisplayString(fileName.value), 1)) : _createCommentVNode("", true)])]), _cache[17] || (_cache[17] = _createElementVNode("div", {
        class: "submit-container"
      }, [_createElementVNode("button", {
        type: "submit",
        class: "submit-button"
      }, "提交申请")], -1))], 32)])]), _createVNode(Footer)]);
    };
  }
});